import { useState, useEffect } from 'react';

function getTimeOfDay() {
  // Get current time in US Eastern
  const now = new Date();
  const eastern = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const hour = eastern.getHours();

  // Morning: 3am (3) to noon (12)
  // Day: noon (12) to 3am (3)
  return (hour >= 3 && hour < 12) ? 'morning' : 'day';
}

export function useTimeOfDay() {
  const [timeOfDay, setTimeOfDay] = useState(() => getTimeOfDay());

  useEffect(() => {
    // Check every minute
    const interval = setInterval(() => {
      setTimeOfDay(getTimeOfDay());
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return timeOfDay;
}
